
import React, { useEffect, useMemo, useRef, useState } from 'react'
import trash from '../../../../../assets/restaurant/images/trash.svg';
import { useTranslation } from 'react-i18next';
import { COUPON_CATEGORY_TYPES, COUPON_TYPES, CURRENCY_SYMBOL, ITEM_TYPES, LOADER_TIMEOUT_TIME, SORT_A, SORT_D, SWAL_SETTINGS } from '../../../../../utils/Constants';
import Swal from 'sweetalert2';
// import * as addonService from '../../../services/addons.service';
import { formatePickerDate, getTranslatedKey, globalLoader, handleOffcanvasScroll, handleServerValidations, TrimText, useDebouncing } from '../../../../../utils/commonfunction';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import Skeleton from 'react-loading-skeleton';
import { useNavigate, useParams } from 'react-router-dom';
import RecordNotFound from '../../../shared/recordNotFound';
import { DatePicker, Drawer } from "rsuite";
import CustomPagination from "../../../../admin/common/custompagination";
import isBefore from "date-fns/isBefore";
import { configureLoyaltyPoints, getLoyaltyList, getLoyaltyPointsConfiguration } from "../../../services/loyalty-point-services";
// import { couponList, add, deleteCoupon, edit, detail } from "../../../services/coupon.service";


export default function LoyaltyPoints() {
    const navigate = useNavigate();
    const params = useParams();
    const addFormCloseBtn = useRef();
    const editFormCloseBtn = useRef();
    const { t } = useTranslation();
    const [search] = useState({});
    const [globalSearch, setGlobalSearch] = useState('');
    const [refreshList, setRefreshList] = useState(false);
    const [refreshItemsList, setRefreshItemsList] = useState(null);
    const [loader, setLoader] = useState(true);
    const [itemsLoader, setItemsLoader] = useState(true);
    const [List, setList] = useState([]);
    const [sortConfig, setSortConfig] = useState({ column: "date", order: SORT_D });
    const [page, setPage] = useState(1);
    const [offset, setOffsetPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState();
    const [itemPerPage] = useState(10);
    const [couponDetail, setCouponDetail] = useState({});
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);

    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    useEffect(() => {
        setLoader(true);
        const formData = new FormData();
        if (Object.keys(search).length) {
            formData.append("search", JSON.stringify(search));
        }
        formData.append("global_search", globalSearch);
        // Determine the page number
        let page = params.page;
        setPage(page);

        formData.append("page", page);
        formData.append("per_page", itemPerPage);
        if (sortConfig) {
            formData.append("sort", JSON.stringify(sortConfig));
        }

        getLoyaltyList(formData)
            .then((data) => {
                if (data && data.data) {
                    setList(data.data.list || []);
                    setPage(data.data.page);
                    setOffsetPage(data.data.offset);
                    setTotalRecords(data.data.total_records || 0);
                    if (data.data.list.length == 0 && page > 1) {
                        setPage(page - 1);
                        navigate(`/restaurant/settings/loyalty-points/${page - 1}`);
                    }
                } else {
                    setList([]);
                    setOffsetPage(0);
                    setTotalRecords(0);
                }
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                console.log("error ====> ", error);
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            });
    }, [search, refreshList, globalSearch, params.page, sortConfig]);


    /** Edit record form */
    const editForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            minimum_spend: "",
            points: "",
            needed_points_for_one_currency_unit: "",
            maximum_redeemable_points: "",
            status: 0,
        },
        validationSchema: Yup.object().shape({
            minimum_spend: Yup.number().required(t("restaurant.loyalty_points.validation_minimum_spend_required")).min(1, t("restaurant.loyalty_points.validation_minimum_spend_min")),
            points: Yup.number().required(t("restaurant.loyalty_points.validation_points_required")).min(1, t("restaurant.loyalty_points.validation_points_min")),
            needed_points_for_one_currency_unit: Yup.number()
                .typeError(t("restaurant.loyalty_points.validation_needed_points_for_one_currency_unit_number"))
                .required(t("restaurant.loyalty_points.validation_needed_points_for_one_currency_unit_required"))
                .moreThan(0, t("restaurant.loyalty_points.validation_needed_points_for_one_currency_unit_must_be_greater_than_zero")),
            maximum_redeemable_points: Yup.number()
                .typeError("Invalid value, Please enter a valid number")
                .required("This field is required")
                .moreThan(0, "Value should be greater than 0"),
        }),
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            let data = {
                // o_id: couponDetail?._id,
                ...values
            }
            setEditSubmissionLoader(true);
            configureLoyaltyPoints(data).then((response) => {
                setEditSubmissionLoader(false);
                if (response.success) {
                    Swal.fire({
                        icon: "success",
                        text: "Loyalty configuration saved successfully.",
                        ...SWAL_SETTINGS,
                    });
                    resetForm();
                    setOpenWithHeader(false)
                } else {
                    Swal.fire({
                        icon: "error",
                        text: handleServerValidations(response),
                        ...SWAL_SETTINGS,
                    });
                }
            }).catch((error) => {
                setEditSubmissionLoader(false);
                console.error("Error updating profile", error);
            });
        },
    });
    const prepareGlobalSearch = (value) => {
        setGlobalSearch(value);
    };
    const searchDebounce = useDebouncing(prepareGlobalSearch);


    const onConfigure = () => {
        getLoyaltyPointsConfiguration()
            .then((response) => {
                editForm.setValues({
                    minimum_spend: response?.data?.minimum_spend || "",
                    points: response?.data?.points || '',
                    expire_date: response?.data?.expire_date || '',
                    needed_points_for_one_currency_unit: response?.data?.needed_points_for_one_currency_unit || '',
                    maximum_redeemable_points: response?.data?.maximum_redeemable_points || '',
                    status: response?.data?.status || 0
                });
                setOpenWithHeader(true);
            })
            .catch((err) => {
                // setTimeout(() => { setAttendanceLoader(false) }, LOADER_TIMEOUT_TIME);
                console.log(err);
            });

    }
    return (
        <main id='main-content'>
            <div className='inner-container'>
                <div className='page-header d-flex align-items-center'>
                    <h4 className='heading-title-text'>Loyalty Program</h4>
                </div>
                <div className='card-outer-header d-flex justify-content-between align-items-center mb-4'>
                    <div className='search-box'>
                        <input type='text' className='form-control search-input' placeholder={t("restaurant.loyalty_points.input_placeholder_search")} onInput={(e) => {
                            searchDebounce(e.target.value);
                        }} />
                    </div>
                    <div className='card-head-group d-flex align-items-center gap-2'>
                        <button className='btn btn-primary' onClick={() => { onConfigure() }}>{t('restaurant.loyalty_points.button_configure_loyalty_points')}</button>
                    </div>
                </div>
                <div className="dashboard-content-wraper">
                    <div className="category-list-wrap">
                        {loader ? (
                            <div className="w-100">
                                <Skeleton className="mb-2" height={50} count={5} />
                            </div>
                        ) : List?.length ? (
                            <div className="card card-table">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>{t("restaurant.loyalty_points.s_no")}</th>
                                                    <th>
                                                        {t("restaurant.loyalty_points.label_customer_name")}
                                                    </th>
                                                    <th>
                                                        {t("restaurant.loyalty_points.label_phone_number")}
                                                    </th>

                                                    <th>
                                                        {t("restaurant.loyalty_points.label_total_paid")}
                                                    </th>
                                                    <th>
                                                        {t("restaurant.loyalty_points.label_total_loyalty_points")}
                                                    </th>
                                                    <th>
                                                        {t("restaurant.loyalty_points.label_available_loyalty_points")}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {List.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{offset + index + 1}</td>
                                                            <td>{TrimText(item?.customer_name, 30)}</td>
                                                            <td>{item?.customer_phone_number}</td>
                                                            <td>{CURRENCY_SYMBOL} {item?.total_currency_spent}</td>
                                                            <td>{item?.total_points}</td>
                                                            <td>{item?.current_points_balance}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="table-status-info d-flex justify-content-between align-items-center">
                                        <span>
                                            {t("restaurant.loyalty_points.label_showing")} {offset + List.length} of {totalRecords} {t("restaurant.loyalty_points.label_entries")}
                                        </span>
                                        <nav aria-label="Page navigation example" title={page}>
                                            {totalRecords && totalRecords > 0 ? (
                                                <CustomPagination
                                                    datalength={totalRecords}
                                                    itemperpage={itemPerPage}
                                                    currentPage={page}
                                                    custompath="page"
                                                    setPage={setPage}
                                                    pageRoute={[{ name: "coupons", path: "/restaurant/settings/loyalty-points" }]}
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <RecordNotFound heading="No Records Found" />
                        )}
                    </div>
                </div>
            </div>

            {/* Both Add and Edit form  */}

            <Drawer open={openWithHeader}>
                <Drawer.Header closeButton={false}>
                    <div className="d-flex justify-content-between w-100 align-items-center">
                        <h2 className="mb-0">{t("Configure")}</h2>
                        <button
                            className="btn-icon"
                            onClick={() => {
                                setOpenWithHeader(false);
                                editForm.resetForm();
                            }}
                        >
                            <i className="ri-close-fill"></i>
                        </button>
                    </div>
                </Drawer.Header>
                <Drawer.Body
                    onScroll={(e) => {
                        handleOffcanvasScroll(e, "editEmail", "rsuite");
                    }}
                >
                    <form onSubmit={editForm.handleSubmit}>
                        <div className="mb-3">
                            <div className='d-flex align-items-center justify-content-between'>
                                <label htmlFor='statusField' className="form-label">Use Loyalty Points<span>*</span></label>
                                <div className="form-check form-switch cp">
                                    <input
                                        id="statusField"
                                        className="form-check-input cp"
                                        type="checkbox"
                                        name="status"
                                        checked={editForm?.values?.status === 1}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                editForm.setFieldValue("status", 1);
                                            } else {
                                                editForm.setFieldValue("status", 0);
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("restaurant.loyalty_points.label_minimum_spend")}<span>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("restaurant.loyalty_points.placeholder_minimum_spend")}
                                name="minimum_spend"
                                value={editForm.values.minimum_spend}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            {editForm.touched.minimum_spend && editForm.errors.minimum_spend ? (
                                <div className="text-danger">{t(editForm.errors.minimum_spend)}</div>
                            ) : null}
                            {/* Description text */}
                            <small className="text-muted d-block mt-1">
                                If the minimum amount is 100.<br />
                                Customers earn points for every 100 they spend.<br />
                                Example: 100 spent → Points × 1, 200 spent → Points × 2,<br />
                                150 spent → Points × 1.
                            </small>

                        </div>
                        <div className="mb-3">
                            <label className="form-label">{t("restaurant.loyalty_points.label_points")}<span>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("restaurant.loyalty_points.placeholder_points")}
                                name="points"
                                value={editForm.values.points}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            {editForm.touched.points && editForm.errors.points ? (
                                <div className="text-danger">{t(editForm.errors.points)}</div>
                            ) : null}
                        </div>

                        {/* value of one point in currency */}
                        <div className="mb-3">
                            <label title={`Points equals to ${CURRENCY_SYMBOL}1`} className="form-label">{`Points equals to ${CURRENCY_SYMBOL}1`}<span>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={`Enter how many points equals to ${CURRENCY_SYMBOL}1`}
                                name="needed_points_for_one_currency_unit"
                                value={editForm?.values?.needed_points_for_one_currency_unit}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            <div className="text-secondary"></div>
                            {editForm.touched.needed_points_for_one_currency_unit && editForm.errors.needed_points_for_one_currency_unit ? (
                                <div className="text-danger">{t(editForm.errors.needed_points_for_one_currency_unit)}</div>
                            ) : null}
                        </div>

                        {/* Maximum Redeemable Points */}
                        <div className="mb-3">
                            <label title={`Maximum Redeemable Points`} className="form-label">{`Maximum Redeemable Points`}<span>*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={`Enter maximum redeemable points`}
                                name="maximum_redeemable_points"
                                value={editForm?.values?.maximum_redeemable_points}
                                onChange={editForm.handleChange}
                                onBlur={editForm.handleBlur}
                            />
                            <div className="text-secondary"></div>
                            {editForm.touched.maximum_redeemable_points && editForm.errors.maximum_redeemable_points ? (
                                <div className="text-danger">{t(editForm.errors.maximum_redeemable_points)}</div>
                            ) : null}
                        </div>


                        <div className="button-form">
                            <button type="submit" className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}>
                                {t("Submit")}
                            </button>
                        </div>
                    </form>
                </Drawer.Body>
            </Drawer>

            <div className="offcanvas offcanvas-end right-modal-w" id="view-staff" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasRightLabel">
                        {t("restaurant.loyalty_points.coupon_details")}
                    </h5>
                    <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
                        <i className="ti ti-x"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="view-staff-info">
                        <div className="row gap-4">
                            <div className="col-md-12">
                                <h4>{t("restaurant.loyalty_points.label_coupon_id")}</h4>
                                <p>{couponDetail?.coupon_id ? couponDetail.coupon_id : t("label_not_entered")}</p>
                            </div>

                            <div className="col-md-12">
                                <h4>{t("restaurant.loyalty_points.label_coupon_code")}</h4>
                                <p>{couponDetail?.coupon_code ? couponDetail.coupon_code : t("label_not_entered")}</p>
                            </div>

                            <div className="col-md-12">
                                <h4>{t("restaurant.loyalty_points.label_coupon_category")}</h4>
                                <p>{couponDetail?.coupon_category ? couponDetail.coupon_category : t("label_not_entered")}</p>
                            </div>
                            <div className="col-md-12">
                                <h4>{t("restaurant.loyalty_points.label_type_of_discount")}</h4>
                                <p>{couponDetail?.discount_type ? couponDetail.discount_type : t("label_not_entered")}</p>
                            </div>

                            <div className="col-md-12">
                                <h4>{t("restaurant.loyalty_points.label_amount_of_discount")}</h4>
                                <p>{couponDetail?.discount ? couponDetail.discount : t("label_not_entered")}</p>
                            </div>


                            <div className="col-md-12">
                                <h4>{t("restaurant.loyalty_points.label_expire_date")}</h4>
                                <p>
                                    {formatePickerDate(couponDetail.expire_date)}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

